<template>
  <v-dialog scrollable v-model="model" persistent max-width="1200px">
    <material-card
      :title="$t('components.claims.claim_history_details')"
      icon="description"
      v-if="item && summaryItem"
    >
      <!-- <v-card-text>
        {{ item }}
        {{ summaryItem }}
      </v-card-text> -->
      <v-card-text>
        <div class="row no-gutters">
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.student_number") }}
            <br />
            <span class="minfo">
              {{ item.StudentNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_number") }}
            <br />
            <span class="minfo">
              {{ item.ClaimNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.line_number") }}
            <br />
            <span class="minfo">
              {{ item.LineNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.expense_info.patient_name") }}
            <br />
            <span class="minfo">
              {{ item.PatientName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.description") }}
            <br />
            <span class="minfo">
              {{ item.Description }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.description_french") }}
            <br />
            <span class="minfo">
              {{ item.Description_French }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.date_of_service") }}
            <br />
            <span class="minfo">
              {{ formatDate(item.DateOfService) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.amount_submitted") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(item.AmountSubmitted) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.amount_paid") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(item.AmountPaid) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.eob_message_codes") }}
            <br />
            <span class="minfo">
              {{ item.EOBMessageCodes }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.eob_messages") }}
            <br />
            <span class="minfo">
              {{ item.EOBMessages }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.eob_messages_french") }}
            <br />
            <span class="minfo">
              {{ item.EOBMessages_French }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.co_insurance") }}
            <br />
            <span class="minfo">
              {{ item.CoInsurance }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.benefits.cob") }}
            <br />
            <span class="minfo">
              {{ item.COB }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.percentage") }}
            <br />
            <span class="minfo">
              {{ formatPercentage(item.Percentage) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.eligible_amount") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(item.Eligible_Amount) }}
            </span>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.plan_number") }}
            <br />
            <span class="minfo">
              {{ summaryItem.PlanNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.student_number") }}
            <br />
            <span class="minfo">
              {{ summaryItem.StudentNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.claim_number") }}
            <br />
            <span class="minfo">
              {{ summaryItem.ClaimNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("globals.plan_name") }}
            <br />
            <span class="minfo">
              {{ summaryItem.PlanName }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.total_submitted") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(summaryItem.TotalSubmitted) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.cheque_status") }}
            <br />
            <span class="minfo">
              {{ summaryItem.ChequeStatus }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.cheque_number") }}
            <br />
            <span class="minfo">
              {{ summaryItem.ChequeNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("components.claims_history.header.total_submitted") }}
            <br />
            <span class="minfo">
              {{ formatCurrency(summaryItem.ChequeAmount) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.status_date") }}
            <br />
            <span class="minfo">
              {{ formatDate(summaryItem.StatusDate) }}
            </span>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-2">
            {{ $t("headers.claim_submissions.paid_to") }}
            <br />
            <span class="minfo">
              {{ summaryItem.PaidTo }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$emit('close');item=null;summaryItem=null;" color="primary">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
      <error-handler :error="error"></error-handler>
    </material-card>
    <div v-else>
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  components: {
    ErrorHandler,
  },
  props: ["model", "claimHistoryItem"],
  data() {
    return {
      error: null,
      item: null,
      summaryItem: null,
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
    }),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "getClaimHistoryDetailsByClaimAndPlan",
      "getClaimHistorySummaryByClaim",
    ]),
    async loadData() {
      try {
        this.item = (await this.getClaimHistoryDetailsByClaimAndPlan({
          claimNumber: this.claimHistoryItem.ClaimNumber,
          planNumber: this.claimHistoryItem.PlanNumber,
        })).data;
        this.summaryItem = (await this.getClaimHistorySummaryByClaim({
          claimNumber: this.claimHistoryItem.ClaimNumber,
        })).data;
      } catch (error) {
        this.error = error;
      }
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    formatPercentage(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      return `${(v * 100).toFixed(2)}%`;
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
